import { render, staticRenderFns } from "./SidebarTypeEstablishment.vue?vue&type=template&id=3baa405d"
import script from "./SidebarTypeEstablishment.vue?vue&type=script&lang=js"
export * from "./SidebarTypeEstablishment.vue?vue&type=script&lang=js"
import style0 from "./SidebarTypeEstablishment.vue?vue&type=style&index=0&id=3baa405d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports